<template>
  <div>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="账号所属公司" prop="companyId">
        <el-select
          v-model="form.companyId"
          placeholder="请选择账号所属公司"
          style="width: 260px"
          size="small"
          filterable
        >
          <el-option
            v-for="item in companyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户名" prop="nickName">
        <el-input
          v-model="form.nickName"
          placeholder="请输入用户名"
          size="small"
          style="width: 260px"
        />
      </el-form-item>

      <el-form-item label="真名" prop="realName">
        <el-input
          v-model="form.realName"
          placeholder="请输入真名"
          size="small"
          style="width: 260px"
        />
      </el-form-item>

      <el-form-item label="电话" prop="phone">
        <el-input
          v-model="form.phone"
          placeholder="请输入电话"
          size="small"
          style="width: 260px"
        />
      </el-form-item>

      <el-form-item label="密码" prop="password">
        <el-input
          v-model="form.password"
          show-password
          placeholder="请输入密码"
          size="small"
          style="width: 260px"
        />
      </el-form-item>

      <el-form-item label="用户类型" prop="type">
        <el-select
          v-model.number="form.type"
          placeholder="请选择用户类型"
          size="small"
          style="width: 260px"
        >
          <el-option :value="2" label="保洁员" />
          <el-option :value="3" label="后台用户" />
        </el-select>
      </el-form-item>

      <el-form-item label="审核状态" prop="reviewStatus">
        <el-select
          v-model.number="form.reviewStatus"
          placeholder="请选择审核状态"
          size="small"
          style="width: 260px"
        >
          <!-- <el-option :value="0" label="待审核" /> -->
          <el-option :value="2" label="通过" />
          <el-option :value="3" label="不通过" />
        </el-select>
      </el-form-item>

      <el-form-item label="身份证号" prop="idNumber">
        <el-input
          v-model="form.idNumber"
          placeholder="请输入身份证号"
          size="small"
          style="width: 260px"
        />
      </el-form-item>

      <el-form-item label="职业证书" prop="certificateUrl">
        <el-upload
          class="form-upload"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="onUploadCertificate"
        >
          <el-button slot="trigger" size="small" type="primary"
            >上传图片</el-button
          >
        </el-upload>
        <span v-if="form.certificateUrl" class="thumb">
          <img :src="formatUrl(form.certificateUrl)" class="preview" />
          <img
            @click="form.certificateUrl = ''"
            src="@/assets/delete.png"
            class="delete"
          />
        </span>
      </el-form-item>

      <el-form-item label="身份证图片" prop="idNumberUrl">
        <el-upload
          class="form-upload"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="onUploadIdImage"
          multiple
          :disabled="idNumberUrlList.length >= 2"
        >
          <el-button
            slot="trigger"
            size="small"
            type="primary"
            :disabled="idNumberUrlList.length >= 2"
            >上传图片</el-button
          >
        </el-upload>
        <span
          v-for="(item, index) in idNumberUrlList"
          :key="index"
          class="thumb"
        >
          <img :src="formatUrl(item)" class="preview" />
          <img
            @click="removeIdImage(index)"
            src="@/assets/delete.png"
            class="delete"
          />
        </span>
      </el-form-item>

      <div style="margin-top: 20px">
        <el-button size="small" @click="onCancel">取 消</el-button>
        <el-button type="primary" size="small" @click="onSubmit"
          >提 交</el-button
        >
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "UserAdd",
  data() {
    return {
      companyList: [],
      idNumberUrlList: [],
      form: {
        certificateUrl: "",
        companyId: undefined,
        id: undefined,
        idNumber: "",
        idNumberUrl: "",
        nickName: "",
        password: "",
        phone: "",
        realName: "",
        reviewStatus: undefined,
        roleIds: "",
        type: undefined,
      },
      rules: {
        companyId: [
          { required: true, message: "请输入公司ID", trigger: "blur" },
        ],
        id: [],
        nickName: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        realName: [{ required: true, message: "请输入真名", trigger: "blur" }],
        reviewStatus: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择用户类型", trigger: "change" },
        ],
        certificateUrl: [],
        idNumber: [],
        idNumberUrl: [],
      },
    };
  },
  created() {
    const { id } = this.$route.query || {};
    if (id) {
      this.loadDetail(id);
    }
    this.getCompanyList();
  },
  methods: {
    async getCompanyList() {
      let data = await this.$get("/company/all");
      this.companyList = data;
    },
    formatUrl(url) {
      if (!url) return "";
      return url.indexOf("http") > -1 ? url : this.host + url;
    },
    async onUploadCertificate(file) {
      const param = new FormData();
      param.append("file", file.raw);
      const data = await this.$upload("/File/upload", param);
      this.form.certificateUrl = data;
    },
    async onUploadIdImage(file) {
      const param = new FormData();
      param.append("file", file.raw);
      const data = await this.$upload("/File/upload", param);
      if (this.idNumberUrlList.length < 2) this.idNumberUrlList.push(data);
      this.form.idNumberUrl = this.idNumberUrlList.join(",");
    },
    removeIdImage(index) {
      this.idNumberUrlList.splice(index, 1);
      this.form.idNumberUrl = this.idNumberUrlList.join(",");
    },
    async onSubmit() {
      await this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        const payload = { ...this.form };
        const res = await this.$post("/user/addOrEdit", payload);
        this.$Message.success("提交成功");
        this.$router.replace("/usermanagement");
      });
    },
    onCancel() {
      this.$router.back();
    },
    async loadDetail(id) {
      const data = await this.$get("/user/getUserInfo", { userId: id });
      this.form = {
        certificateUrl: data.certificateUrl || "",
        companyId: data.companyId,
        id: data.userId || data.id,
        idNumber: data.idNumber || "",
        idNumberUrl: data.idNumberUrl || "",
        nickName: data.nickName || "",
        password: "",
        phone: data.phone || "",
        realName: data.realName || "",
        reviewStatus: data.reviewStatus,
        roleIds: data.roleIds || "",
        type: data.type,
      };
      this.idNumberUrlList = (
        data.idNumberUrl ? data.idNumberUrl.split(",") : []
      ).filter(Boolean);
    },
  },
};
</script>

<style scoped>
.thumb {
  display: inline-block;
  width: 100px;
  height: 100px;
  position: relative;
  margin-right: 8px;
}
.preview {
  height: 80px;
  width: 80px;
  padding: 10px;
}
.delete {
  height: 20px;
  width: 20px;
  position: absolute;
  right: 0;
  cursor: pointer;
}
</style>
